"use client";

import { useResizeMessage } from "@justhome/common/hooks";
import { EmbeddedBudgetCheck } from "@justhome/forms";

const BudgetCalculator = () => {
  useResizeMessage("justhome-budget-check");

  return <EmbeddedBudgetCheck locale="immo" hasExplicitOptIn />;
};

export default BudgetCalculator;
